/**
 *  © 2024-2025 DXC Technology, all rights reserved.
 *  Material published by DXC Technology on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect, useState } from 'react';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';
import ImgCrop from '../Common/ImgCrop';
import { MyUnitedProvider, useMyUnitedValue } from '../../context/myUnitedContext';
import { useSponsorValue } from '../../context/sponsorContext';
import { fetchUnitedConfigData } from '../../actions/myUnitedAction';
import { buildImgUrl, getParameterByName } from '../../utils/utils';
import MU from '../../constants/muConstants';
import { checkLocalCodeMissing, createBaseUrl, redirectToIDMLogin } from '../../utils/idmUtils';
import { redirectToSignIn } from '../../utils/gigyaScreen';
import moment from 'moment';
import Sponsor from '../Common/Sponsor';
import { DARK_THEME, MODULE } from '../../constants/globalConstants';
import Loader from '../Common/Loader';
const braze = typeof window !== 'undefined' && !isEditorActive() ? require('@braze/web-sdk') : null;

const UnitedRewards = (props) => (
  <React.Fragment>
    <MyUnitedProvider>
      <UnitedRewardsContainer {...props}></UnitedRewardsContainer>
    </MyUnitedProvider>
  </React.Fragment>
);
const UnitedRewardsContainer = (props) => {
  const { t } = props;
  const [{ isGigyaAvilable, userLoginDetail }, sponsorDispatch] = useSponsorValue();
  const [{ unitedNowConfigData }, dispatch] = useMyUnitedValue();
  const [gigyaData, setgigyaData] = useState(null);
  const [contentCards, setContentCards] = useState(null);
  const { EnableHero, UnitedrewardsImage, UnitedRewardsTitle, SponsortText } = props.fields;

  useEffect(() => {
    if (braze?.getUser() && !contentCards) {
      braze.subscribeToContentCardsUpdates((events) => {
        if (events?.cards?.length > 0) {
          const sortEvents = events?.cards.filter(
            (card) => card.extras.container_type === 'rewards'
          );
          setContentCards(sortEvents);
        }
      });
      braze.requestContentCardsRefresh();
    }
  }, [braze?.getUser()]);

  useEffect(() => {
    if (MU.isIDMEnabled) {
      const code = getParameterByName('code', true);
      const error = getParameterByName('error', true);
      if (error && error === 'login_required') {
        window.location = createBaseUrl();
      } else if (checkLocalCodeMissing() && !code) {
        redirectToIDMLogin();
      }
    } else {
      redirectToSignIn();
    }
  }, [isGigyaAvilable]);

  useEffect(() => {
    if (isGigyaAvilable && userLoginDetail) {
      setgigyaData(userLoginDetail);
      fetchUnitedConfigData(dispatch);
    }
  }, [isGigyaAvilable, userLoginDetail]);

  const unitedNowConfigResponse =
    unitedNowConfigData?.UnitednowconfigurationsResponse?.response?.docs[0];

  const earnrewardtitle = unitedNowConfigResponse?.earnrewardtitle_t;
  const earnrewarddescription = unitedNowConfigResponse?.earnrewarddescription_t;
  const earnrewardctatitle = unitedNowConfigResponse?.earnrewardctatitle_t;
  const earnrewardctaurl = unitedNowConfigResponse?.earnrewardctaurl_t;
  const noofferheadline = unitedNowConfigResponse?.noofferheadline_t;
  const noofferdescription = unitedNowConfigResponse?.noofferdescription_t;
  const celumimagesvariant_s = unitedNowConfigResponse?.celumimagesvariant_s?.ImageDetails[0];
  const additionalsupportheadline = unitedNowConfigResponse?.additionalsupportheadline_t;
  const additionalsupportdata = unitedNowConfigResponse?.additionalsupportdata_t;
  const rewardexpirestext = unitedNowConfigResponse?.rewardexpirestext_t;

  const getRemainingTime = (expiresAt) => {
    const now = moment();
    const expiry = moment(expiresAt);
    const diffInMinutes = expiry.diff(now, 'minutes');
    const diffInHours = expiry.diff(now, 'hours');
    const diffInDays = expiry.diff(now, 'days');

    if (diffInDays < 1 && diffInMinutes > 60) {
      return {
        text: `${rewardexpirestext} ${diffInHours} ${t('RewardsHours')}`,
        isExpiring: true,
      };
    } else if (diffInDays < 1) {
      return {
        text: `${rewardexpirestext} ${diffInMinutes} ${t('RewardsMins')}`,
        isExpiring: true,
      };
    } else {
      return {
        text: `${rewardexpirestext} ${diffInDays} ${t('RewardsDays')}`,
        isExpiring: diffInDays <= 1,
      };
    }
  };

  const handleClick = async (e, link_code, link_url) => {
    if (link_code) {
      try {
        await window.navigator.clipboard.writeText(link_code);
        //alert('Copied to clipboard!');
      } catch (err) {
        console.error('Unable to copy to clipboard.', err);
      }
    } else if (link_url) {
      window.location = link_url;
    }
  };

  const cards =
    typeof document !== 'undefined' && document && document.querySelectorAll('.contentBox');

  cards?.length > 0 &&
    cards.forEach((card) => {
      const description = card.querySelector('.description');
      const contentBox = card.classList[0];
      if (description && contentBox) {
        // Get the inner height of the description element
        const height = description.clientHeight; // height in pixels

        if (height > 25) {
          // Add a new class to the card
          card.classList.add('long-description');
        }
      }
    });

  return (
    <React.Fragment>
      {gigyaData && gigyaData.data ? (
        <div className="unitedRewards">
          <div className="grid-12 ratio heroImg ">
            <div className="mu-content">
              <div className="mu-item xlarge">
                {EnableHero?.value && (
                  <div className="img-holder nobg">
                    {UnitedrewardsImage?.value?.Crops?.img1x && (
                      <ImgCrop
                        imgCrop={UnitedrewardsImage.value.Crops.img1x}
                        alt={UnitedrewardsImage.value.AltText}
                        title={UnitedrewardsImage.value.AltText}
                        isWebpAvailable={UnitedrewardsImage.value.isWebpAvailable}
                        singleSrc={true}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="container">
            <div className="headContainer">
              {UnitedRewardsTitle?.value && <p className="pageTitle">{UnitedRewardsTitle.value}</p>}
              <div className="Sponsor">
                {SponsortText?.value && <p>{SponsortText.value}</p>}
                <Sponsor type={MODULE} moduleName="unitedrewards" theme={DARK_THEME}></Sponsor>
              </div>
            </div>
            <div className="containerBox">
              <div className="main_component">
                {contentCards === null ? (
                  <Loader />
                ) : contentCards?.length > 0 ? (
                  <div className="custom_brazeContentCard">
                    {contentCards.map((card, index) => {
                      const { text, isExpiring } = getRemainingTime(card.expiresAt);
                      const title_highlight = card?.extras?.title_highlight;
                      let partsTitle_highlight;
                      let lowerTitle_highlight;
                      if (title_highlight) {
                        lowerTitle_highlight = title_highlight.toLowerCase();
                        partsTitle_highlight = card?.title.split(
                          new RegExp(`(${title_highlight})`, 'gi')
                        );
                      }

                      const message_highlight = card?.extras?.message_highlight;
                      let partsMessage_highlight;
                      let lowerMessage_highlight;
                      if (title_highlight) {
                        lowerMessage_highlight = message_highlight.toLowerCase();
                        partsMessage_highlight = card?.description.split(
                          new RegExp(`(${message_highlight})`, 'gi')
                        );
                      }
                      return (
                        <div key={index} className={`contentCard contentCard${index}`}>
                          <div className={`imgBox ${!card.imageUrl && `img-holder`}`}>
                            {card?.imageUrl && (
                              <div className="imgContent">
                                <img src={card.imageUrl} alt="braze content logo" />
                              </div>
                            )}
                          </div>

                          <div
                            className="contentBox"
                            style={{ backgroundColor: card.extras.background_colour }}
                          >
                            <div className="content">
                              <div className="containerData">
                                {card?.title && title_highlight ? (
                                  <p className="title">
                                    {partsTitle_highlight?.map((partsTitle, index) =>
                                      partsTitle.toLowerCase() === lowerTitle_highlight ? (
                                        <span className={card?.extras?.title_style} key={index}>
                                          {partsTitle}
                                        </span>
                                      ) : (
                                        partsTitle
                                      )
                                    )}
                                  </p>
                                ) : (
                                  card?.title && <p className="title">{card.title}</p>
                                )}

                                {card?.description && message_highlight ? (
                                  <p className="description">
                                    {partsMessage_highlight?.map((partsMessage, index) =>
                                      partsMessage.toLowerCase() === lowerMessage_highlight ? (
                                        <span className={card?.extras?.message_style} key={index}>
                                          {partsMessage}
                                        </span>
                                      ) : (
                                        partsMessage
                                      )
                                    )}
                                  </p>
                                ) : (
                                  card?.description && (
                                    <p className="description">{card.description}</p>
                                  )
                                )}
                              </div>
                              {card?.expiresAt && (
                                <div className={`expirestime ${isExpiring ? 'expiring' : ''}`}>
                                  {isExpiring ? (
                                    <i className="ico icon-expire_clock_red"></i>
                                  ) : (
                                    <i className="ico icon-expire_clock"></i>
                                  )}
                                  <p>{text}</p>
                                </div>
                              )}
                            </div>
                            <div className="btn">
                              {card?.linkText && (
                                <div className="btnBox red-btn-skew">
                                  <a href={card?.url ? card?.url : '#'}>{card.linkText}</a>
                                </div>
                              )}
                              {card?.extras?.link2_text && (
                                <div className="btnBox white-btn-skew">
                                  <a
                                    onClick={(e) =>
                                      handleClick(e, card.extras.link2_code, card.extras.link2_url)
                                    }
                                  >
                                    {card.extras.link2_text}
                                  </a>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  (noofferheadline || noofferdescription) && (
                    <div className="no_rewards">
                      <div className="mood_ico">
                        <i className="icon-no_rewards_mood"></i>
                      </div>
                      {noofferheadline && <p className="headline">{noofferheadline}</p>}
                      {noofferdescription && <p className="desc">{noofferdescription}</p>}
                    </div>
                  )
                )}
              </div>
              {contentCards !== null && (
                <div className="sidebar">
                  {unitedNowConfigResponse && (
                    <>
                      <div className="earnRewardBox">
                        <div className="contentBox">
                          {earnrewardtitle && <p className="title">{earnrewardtitle}</p>}
                          {earnrewarddescription && <p className="desc">{earnrewarddescription}</p>}
                          {earnrewardctatitle && earnrewardctaurl && (
                            <a target="_self" href={earnrewardctaurl}>
                              {earnrewardctatitle}
                            </a>
                          )}
                        </div>
                        {celumimagesvariant_s?.CropUrl?.img1x && (
                          <div className="imgBox">
                            <img
                              src={buildImgUrl(celumimagesvariant_s.CropUrl.img1x)}
                              alt={celumimagesvariant_s.AltText}
                              title={celumimagesvariant_s.Name}
                            />
                          </div>
                        )}
                      </div>
                      <div className="add_support">
                        {additionalsupportheadline && (
                          <p className="title">{additionalsupportheadline}</p>
                        )}
                        {additionalsupportdata?.length > 0 &&
                          additionalsupportdata.map((data, key) => {
                            return (
                              data.additionalsupporttitle_t &&
                              data.additionalsupportctaurl_t && (
                                <div className="dataBox">
                                  <a key={key} target="_self" href={data.additionalsupportctaurl_t}>
                                    {data.additionalsupporttitle_t}
                                    <i className="icon-chevron-right"></i>
                                  </a>
                                </div>
                              )
                            );
                          })}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Loader></Loader>
      )}
    </React.Fragment>
  );
};

export default withTranslation()(React.memo(UnitedRewards));
